import { render, staticRenderFns } from "./EventCalendarMonth.vue?vue&type=template&id=c3650de6&"
import script from "./EventCalendarMonth.vue?vue&type=script&lang=js&"
export * from "./EventCalendarMonth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports